import React, { FC, ReactNode } from 'react';
import { Icon }                 from 'semantic-ui-react';

interface Props {
	label?: ReactNode,
}

const defaultProps: Props = {
	label: 'Loading...',
}

const InlineLoadingIndicatorLabel: FC<Props> = ( props ) => {
	
	return (
		<span className={ 'display--inline-block margin-xs-horizontal' }>
			<Icon loading name='circle notch' className={ 'margin-xs-right' }/>{ props.label }
		</span>
	);
	
};

InlineLoadingIndicatorLabel.defaultProps = defaultProps;

export { InlineLoadingIndicatorLabel }
